<!-- A title section with a folding body -->
<script lang="ts" setup>
    import { ref, watch, onMounted, computed, nextTick } from 'vue';

    const props = withDefaults(defineProps<{
        panelOpen?: boolean,
        cssFramework?: "bootstrap" | "billing" | "vanilla" | "simpleSmall",
        headerTitle?: string,
        headerStyle?: "normal" | "medium"
    }>(), {
        panelOpen: true,
        cssFramework: "bootstrap",
        headerStyle: "normal"
    });
    
    const emit = defineEmits(["update:panelOpen", "opened", "closed"]);

    const isPanelOpen = ref<boolean>(true);

    onMounted(() =>{
        isPanelOpen.value = props.panelOpen;
    });

    watch(() => props.panelOpen, (newVal, _oldVal) => {
        isPanelOpen.value = newVal;
    });

    const toggleCardClass = computed(() => {
        return (props.cssFramework === "billing" || props.cssFramework === "simpleSmall" ? "" :  "card") +  " SectionPadding";
    });

    const toggleHeaderClass = computed(() => {
        let result = "";
        switch (props.cssFramework) {
            case "billing": result = "cardChevronColor cardFontSize bg-white"; break;
            case "simpleSmall": result = "card-header cardSmallSize "; break;
            default: result = "card-header text-white bg-primary"; break;
        }        
        return result +  " ActionCursor";
    });

    const toggleIconClass = computed(() => {
        return (isPanelOpen.value ? "fa-solid fa-chevron-down" : "fa-solid fa-chevron-right")  + (props.cssFramework === "billing" ? " cardChevronColor" : "");
    });

    const headerStyle = computed(() =>{
        switch (props.headerStyle)
        {
            case "medium":
                return "font-size:1.25rem";
        }
    });

    async function togglePanel()
    {
        isPanelOpen.value = !isPanelOpen.value;
        emit("update:panelOpen", isPanelOpen.value);

        // Let the outside world know we've opened the panel
        await nextTick(() => {
            if (isPanelOpen.value)
                emit("opened");
            else
                emit("closed");
        });
    };
</script>

<style scoped>
    [v-cloak] {
        display: none
    }
   
    .ActionCursor {
        cursor: pointer;
    }

    .card-border {
        border-left-color: gray;
        border-right-color: gray;
        border-bottom-color: gray;
    }
    .cardChevronColor {
        color: #204D89;
    }
    .cardFontSize {
        font-size: .85rem; 
    }
    .cardSmallSize {
        font-size: .75rem; 
    }
    .card-padding {
        padding: 1rem;
    }
</style>

<template>
    <div :class="toggleCardClass" class="mb-1" v-cloak>
        <div :class="toggleHeaderClass"
            @click="togglePanel"
            :title="headerTitle"
            :style="props.headerStyle">
            
            <em :class="toggleIconClass" style="width:1.2em; display:inline-block"></em>

            <span>
                <slot name="title">
                    <span style="color:red">Need slot data: title</span>
                </slot>
                <slot name="marker">
                </slot>
            </span>
        </div>
        <div class="card-body card-padding card-border" v-if="isPanelOpen">
            <slot name="body">
                <span style="color:red">Need slot data: body</span>
            </slot>
        </div>
    </div>
</template>
